import type { ReactElement, ReactNode } from 'react';
import { SizableText } from 'tamagui';

export const SectionWarning = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => (
  <SizableText
    size="$3"
    fontFamily="$body"
    color="$warningFont"
    backgroundColor="$warningBg"
    padding="$2"
    borderRadius="$true"
  >
    {children}
  </SizableText>
);
